import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// Components
import GuestPage from "../../Components/GuestPage";
import Page from "../../Components/Page";
import SecondaryButton from "../../Components/SecondaryButton";
import { NavigateBeforeIcon } from "../../Styles/Icons";
import styles from "./styles.module.scss";

const GDPR = () => {
  return (
    <div className={styles.policy}>
      <h1>Friends and Family GDPR Notice</h1>

      <p>
        <strong>For GDPR purposes</strong>, Lilli is required to obtain consent
        (as defined under data protection legislation) to:
      </p>
      <ol>
        <li>1. Share the service user’s Lilli profile and related data; and</li>
        <li>
          2. Store and use the name and contact details of the friend or family
          member.
        </li>
      </ol>

      <br></br>
      <p>
        <strong>Data to be shared:</strong>
      </p>
      <ol>
        <li>
          1. The service user’s Lilli profile data, collected via the Lilli
          mobile app by Intelligent Lilli Ltd, which is used to help assess the
          service user’s care requirements.
        </li>
        <li>
          2. Additional information provided by your care organisation about the
          service user, such as name, care type, and date of birth.
        </li>
      </ol>

      <br />
      <p>
        <strong>Duration of data sharing:</strong>
        <br /> <br />
        The data will be shared with the identified friend or family member
        until consent is withdrawn by contacting&nbsp;
        <a href="mailto:support@intelligentlilli.com">
          support@intelligentlilli.com
        </a>
        .
      </p>

      <hr />
      <br />
      <p>
        <strong>Your agreement to share data:</strong>
        <br />
        <br />
        I consent on behalf of my organisation, identified as the data
        controller in this instance, to share this service user’s Lilli data
        with their friend or family member.
        <br />
        <br /> Additionally, the identified friend or family member has given
        consent for me to share their contact details with Lilli.
        <br />
        <br /> These details are shared for the purpose of providing them with
        access to the{" "}
        <span style={{ textDecoration: "underline" }}>
          Lilli Friends and Family Mobile App
        </span>
        .
      </p>
    </div>
  );
};

function FriendsAndFamilyGDPR() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  if (user) {
    return (
      <Page>
        <GDPR />
      </Page>
    );
  } else {
    return (
      <GuestPage
        subtitle={
          <SecondaryButton
            startIcon={<NavigateBeforeIcon />}
            onClick={() => navigate("/login")}
          >
            Back to Login
          </SecondaryButton>
        }
        removeSandBackground={true}
      ></GuestPage>
    );
  }
}

export default FriendsAndFamilyGDPR;
